var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 18V16.5H9V15H8C6.89333 15 5.95 14.61 5.17 13.83C4.39 13.05 4 12.1067 4 11C4 10.2778 4.17708 9.60417 4.53125 8.97917C4.88542 8.35417 5.375 7.86111 6 7.5C6 6.80556 6.23958 6.21528 6.71875 5.72917C7.19792 5.24306 7.78472 5 8.47917 5H8.75L8.35417 3.97917L9.52083 3.52083L9.14583 2.54167L10.5417 2L10.9167 2.95833L12.0833 2.5L14.6458 9.02083L13.4792 9.47917L13.8542 10.4583L12.4583 11L12.0625 10.0208L10.9167 10.5L10.3958 9.125C10.1597 9.40278 9.875 9.61806 9.54167 9.77083C9.20833 9.92361 8.85979 10 8.49604 10C8.0959 10 7.72222 9.91319 7.375 9.73958C7.02778 9.56597 6.73611 9.31944 6.5 9C6.18056 9.23611 5.93403 9.52639 5.76042 9.87083C5.58681 10.2153 5.5 10.5917 5.5 11C5.5 11.6944 5.74306 12.2847 6.22917 12.7708C6.71528 13.2569 7.30556 13.5 8 13.5H15V15H11V16.5H16V18H4ZM11.75 8.54167L12.6875 8.1875L11.2292 4.45833L10.2917 4.8125L11.75 8.54167ZM9.20833 8.20833C9.40278 8.01389 9.5 7.77778 9.5 7.5C9.5 7.22222 9.40278 6.98611 9.20833 6.79167C9.01389 6.59722 8.77778 6.5 8.5 6.5C8.22222 6.5 7.98611 6.59722 7.79167 6.79167C7.59722 6.98611 7.5 7.22222 7.5 7.5C7.5 7.77778 7.59722 8.01389 7.79167 8.20833C7.98611 8.40278 8.22222 8.5 8.5 8.5C8.77778 8.5 9.01389 8.40278 9.20833 8.20833Z",
    fill: "#0F2E70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile13);
export default __webpack_public_path__ + "static/media/profile-13.b6203930c4efcd6deafdd930d2ea1e36.svg";
export { ForwardRef as ReactComponent };